import React from "react";

import classes from "./Particals.module.scss";

function Particals() {
  return (
    <div>
      <div className={classes.wrap}>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
        <div className={classes.c}></div>
      </div>
    </div>
  );
}

export default Particals;
